/* eslint-disable no-unused-vars */
import { createContext, useState, useEffect, useContext, useMemo } from "react";
import Storage from "../libs/storage";

const API_URL = process.env.REACT_APP_API_URL;

const MessagesContext = createContext();

export const MessagesProvider = ({ children }) => {
  const storage = useMemo(() => Storage(), []);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const blockScreens = useMemo(() => data?.flatMap(item => item.blockedAreas || []), [data]);
  const [showMessageNotice, setShowMessageNotice] = useState(false);

  useEffect(() => {
    if (data.some(item => item.highlight === true)) {
      setShowMessageNotice(true);
    }
  }, [data]);

  //  useEffect(() => {
    // const fetchMessages = async () => {
    //   try {
    //     setLoading(true);
    //     setError(null);

    //     const data = await storage.getItem("data");
    //     if (!data) throw new Error("Usuário não autenticado");

    //     const headers = {
    //       "Content-Type": "application/json; charset=utf-8",
    //       Authorization: data.token,
    //     };

    //     const response = await fetch(`${API_URL}/user/graphql`, {
    //       method: "POST",
    //       headers,
    //       body: JSON.stringify({
    //         query: `
    //           query AllMessagesInLast12Months {
    //             allMessagesInLast12Months {
    //               id
    //               createdAt
    //               title
    //               message
    //               platformWeb
    //               platformApp
    //               highlight
    //               blockedAreas
    //               companyId
    //               onlyOwner
    //             }
    //           }
    //         `,
    //       }),
    //     });

    //     if (!response.ok) {
    //       throw new Error("Erro ao buscar mensagens");
    //     }

    //     const result = await response.json();

    //     const filtered = result.data.allMessagesInLast12Months.filter(
    //       (msg) => msg.platformWeb === true
    //     );

    //     setData(filtered);
    //   } catch (err) {
    //     setError(err.message || "Erro desconhecido");
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    // fetchMessages();
  // }, [storage]);

  return (
    <MessagesContext.Provider value={{ data, loading, error, blockScreens, showMessageNotice, setShowMessageNotice }}>
      {children}
    </MessagesContext.Provider>
  );
};

export const useMessages = () => {
  return useContext(MessagesContext);
};
